import { render } from "./StoreGift.vue?vue&type=template&id=d4d41c6c&scoped=true"
import script from "./StoreGift.vue?vue&type=script&lang=js"
export * from "./StoreGift.vue?vue&type=script&lang=js"

import "./StoreGift.vue?vue&type=style&index=0&id=d4d41c6c&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4d41c6c"]])

export default __exports__